import React, { forwardRef } from 'react';
import styles from '../client-menu.styles.css';
import { CpIcon, CpArea } from 'canopy-styleguide!sofe';

export default forwardRef(function ClientMenuTrigger(props, ref) {
  const {toggle, userEntity, activeClient} = props
  return (
    <CpArea className={`${styles.dropdownTrigger}`} onClick={toggle} ref={ref}>
      <div className={styles.triggerContent}>
        <div className={styles.circleLabel}>{activeClient?.initials || userEntity?.initials}</div>
        <div className={`${styles.label}`}>
          <div className={`${styles.name}`}>
            {activeClient?.name || userEntity?.name}
          </div>
          <div className='cps-ellipsis cps-caption cps-wt-semibold'>
            {userEntity?.company_name}
          </div>
        </div>
      </div>
      <CpIcon name="caret-large-down" />
    </CpArea>
  )
});